export function not(a, b) {
  return a.filter((value) => getValueCurrentIndex(b, value) === -1);
}

export const intersection = (checked, items) =>
  checked.filter((value) => getValueCurrentIndex(items, value) !== -1);

export const union = (checked, items) => [...checked, ...not(items, checked)];

export const numberOfChecked = (items, checked) =>
  intersection(checked, items)?.length || 0;

export const getValueCurrentIndex = (items, value) =>
  items?.findIndex((v) => v === value);

export const getItemsToChoose = (
  itemsToChoose,
  itemsSelected,
  targetEqualityCriteria
) => {
  return (
    itemsToChoose?.filter(
      (item) =>
        !itemsSelected?.find(
          (selectedItem) =>
            `${selectedItem?.[targetEqualityCriteria]}` ===
            `${item?.[targetEqualityCriteria]}`
        )
    ) || []
  );
};

export const getNamesFormItemsHandler = (itemList, targetProp) => {
  return itemList?.map((item) => item[targetProp]) || [];
};
